import { render, staticRenderFns } from "./DetallesValuador.vue?vue&type=template&id=2aa9801d&scoped=true"
import script from "./DetallesValuador.vue?vue&type=script&lang=js"
export * from "./DetallesValuador.vue?vue&type=script&lang=js"
import style0 from "./DetallesValuador.vue?vue&type=style&index=0&id=2aa9801d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9801d",
  null
  
)

export default component.exports